import gql from "graphql-tag";

export const SIGN_UP_VERIFY = gql`

mutation verifyaccount($id: String!) {
    verifyUserAccount(input: { id: $id }) {
      success
      message
    }
  }
  
`;
